export default function (Alpine) {
    Alpine.store('callForm', {
        open: false,
        type: 'Запросить расчёт', // значение по умолчанию

        show(type = 'Запросить расчёт') {
            this.type = type
            this.open = true
        },

        hide() {
            this.open = false
        }
    })
}
